<template>
  <avs-switch
    mdi2="mdi-white-balance-sunny"
    mdi1="mdi-moon-waning-crescent"
    :spantext="$t('messages.information.switch_theme')"
    :value="!isThemeDark"
    @switch="v => switchIsThemeDark(!v)"
  />
</template>

<script>
export default {
  name: "ThemeSwitch",
  props: {},
  data() {
    return {
      isThemeDark: this.$store.state.app.isThemeDark
    }
  },
  computed: {
    icon() {
      return this.$store.state.app.isThemeDark
        ? "mdi-white-balance-sunny"
        : "mdi-moon-waning-crescent"
    }
  },

  methods: {
    switchIsThemeDark(newValue) {
      this.$vuetify.theme.dark = newValue
      this.$store.commit("app/setIsThemeDark", newValue)
    }
  }
}
</script>
